// extracted by mini-css-extract-plugin
export default {"header__logoLink":"headerLogo_header__logoLink__pkq2l"};